import React from 'react';
import PropTypes from 'prop-types';
import Question from '../../common/Question';
import TextAreaInput from '../../common/TextAreaInput';
import YesNoInputGroup from '../../common/YesNoInputGroup';
import './CertificationsTab.scss';
function CertificationsTab(_ref) {
  var project = _ref.project,
    proposal = _ref.proposal,
    onFormChange = _ref.onFormChange,
    errors = _ref.errors;
  var educationExampleText = 'I am not PMP certified but I have held various IT PM roles at Accenture, Pfizer and J&J.';
  var degrees = project.degrees,
    accreditations = project.accreditations;
  var numberIndexes = [1, 2];
  return /*#__PURE__*/React.createElement("div", {
    className: "qualifications-tab mb-4"
  }, degrees.length === 0 && accreditations.length === 0 && /*#__PURE__*/React.createElement("div", {
    className: "body-text-2 mb-4"
  }, "The Employer has not specified any requirements"), degrees.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(Question, {
    title: "".concat(numberIndexes.shift(), ". Do you meet these educational requirements?"),
    className: "qualifications-question",
    location: "proposal-edit"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ms-4 degrees-question"
  }, /*#__PURE__*/React.createElement(YesNoInputGroup, {
    options: degrees,
    formKey: "degrees",
    value: proposal.degrees,
    onAnswerChange: function onAnswerChange(val) {
      return onFormChange('degrees', val);
    },
    errors: errors
  }), proposal.degrees && proposal.degrees.some(function (el) {
    return el.selected === 'No';
  }) && /*#__PURE__*/React.createElement("div", {
    className: "degrees-description"
  }, errors && errors.degrees_desc && /*#__PURE__*/React.createElement("div", {
    className: "body-text-2 medium-weight with-error-text mb-2"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-exclamation-triangle"
  }), ' ', "Required!"), /*#__PURE__*/React.createElement(TextAreaInput, {
    placeholder: "Tell us more.",
    onAnswerChange: function onAnswerChange(val) {
      return onFormChange('degrees_desc', val);
    },
    value: proposal.degrees_desc,
    error: errors.degrees_desc,
    textPromptClass: errors && errors.degrees_desc && 'with-error-text',
    exampleText: educationExampleText
  }))))), accreditations.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(Question, {
    className: "qualifications-question",
    title: "".concat(numberIndexes.shift(), ". Do you meet the following certification requirements?"),
    location: "proposal-edit"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ms-4 accreditations-question"
  }, /*#__PURE__*/React.createElement(YesNoInputGroup, {
    options: accreditations,
    formKey: "accreditations",
    value: proposal.accreditations,
    onAnswerChange: function onAnswerChange(val) {
      return onFormChange('accreditations', val);
    },
    errors: errors
  }), proposal.accreditations && proposal.accreditations.some(function (el) {
    return el.selected === 'No';
  }) && /*#__PURE__*/React.createElement("div", {
    className: "accreditations-description"
  }, errors && errors.accreditations_desc && /*#__PURE__*/React.createElement("div", {
    className: "body-text-2 medium-weight with-error-text mb-2"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-exclamation-triangle"
  }), ' ', "Required"), /*#__PURE__*/React.createElement(TextAreaInput, {
    placeholder: "Tell us more.",
    onAnswerChange: function onAnswerChange(val) {
      return onFormChange('accreditations_desc', val);
    },
    value: proposal.accreditations_desc,
    error: errors.accreditations_desc,
    textPromptClass: errors && errors.accreditations_desc && 'with-error-text'
  }))))));
}
CertificationsTab.propTypes = {
  project: PropTypes.shape({}).isRequired,
  proposal: PropTypes.shape({}).isRequired,
  onFormChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({}).isRequired
};
export default CertificationsTab;